export const compareCaseInsensitive = (str1 = '', str2 = '') => {
  return str1.localeCompare(str2, undefined, { sensitivity: 'base' })
}
